<div class="container">
    <div style="padding-top: 60px;">
        <div [innerHTML]="wording" style="color: white;font-family: Roboto;padding: 20px;"></div>
    </div>
    <div style="text-align: center;">
        <app-product></app-product>
    </div>
</div>